/**
 * Contact Component (Homepage)
 * 
 * CTA section for homepage - now uses shared CTASection component.
 * This file is kept for backwards compatibility and homepage-specific use.
 * 
 * @component
 * @deprecated Use CTASection component directly for new pages
 */

import { memo } from "react";
import { CTASection } from "@/components/common/CTASection";

const Contact = () => {
  return <CTASection />;
};

export default memo(Contact);
